import { CompileMessageType, STATUS_ICON_CONFIG } from '#ink'

import { FaIcon, FaIconProps } from './FaIcon'

type StatusIconProps = Omit<FaIconProps, 'color' | 'icon'>

export const CompilerStatusIcon = ({
  type,
  ...props
}: StatusIconProps & { type: CompileMessageType }) => {
  const { iconClass, color } = STATUS_ICON_CONFIG[type]
  return <FaIcon icon={iconClass} color={color} {...props} />
}
